import React from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';

const LearnMore = ({content, playsInline}) => {

  return (
    <div className={`ssc__learn-more ssc__learn-more--${content.class}`}>

      <h2 className="with-hr">
        {content.subtitle &&
          <span>{content.subtitle}</span>
        }
        <span>{content.title}</span>
      </h2>

      <p>{content.description}</p>

      {content.video &&
        <VideoPlayer
          src={content.video}
          poster={content.videoPoster}
          captions={content.videoCaptions}
          playsInline={playsInline}
          customStyle={{margin: '2em 0'}}
        />
      }
      <ul>
      	{content.steps.map( (step, idx) =>
      		<li key={idx}>
      			<h3>{step.label}</h3>
      			<p>{step.description}</p>
      		</li>
      	)}
      </ul>
      
    </div>

  );

}

export default LearnMore;


// WEBPACK FOOTER //
// ./src/components/LearnMore/LearnMore.js